import { render } from "./Project68BatchProcessor.vue?vue&type=template&id=a2583e6a&scoped=true"
import script from "./Project68BatchProcessor.vue?vue&type=script&lang=js"
export * from "./Project68BatchProcessor.vue?vue&type=script&lang=js"

import "./Project68BatchProcessor.vue?vue&type=style&index=0&id=a2583e6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2583e6a"]])

export default __exports__